export const TKeyMessagesSequences = {
  MESSAGES_SEQUENCES_NAV: "MESSAGES_SEQUENCES_NAV",
  MESSAGES_SEQUENCES_TITLE: "MESSAGES_SEQUENCES_TITLE",
  MESSAGES_SEQUENCES_SUBTITLE: "MESSAGES_SEQUENCES_SUBTITLE",
  MESSAGES_SEQUENCES_SEQUENCE_TITLE: "MESSAGES_SEQUENCES_SEQUENCE_TITLE",
  MESSAGES_SEQUENCES_SEQUENCE_EMPTY: "MESSAGES_SEQUENCES_SEQUENCE_EMPTY",
  MESSAGES_SEQUENCES_CARD_TITLE: "MESSAGES_SEQUENCES_CARD_TITLE",
  MESSAGES_SEQUENCES_CARD_DESCRIPTION: "MESSAGES_SEQUENCES_CARD_DESCRIPTION",
  MESSAGES_SEQUENCES_CARD_CTA: "MESSAGES_SEQUENCES_CARD_CTA",
  MESSAGES_SEQUENCES_SELECT_OFFER_LABEL: "MESSAGES_SEQUENCES_SELECT_OFFER_LABEL",
  MESSAGES_SEQUENCES_SELECT_AVATAR_LABEL: "MESSAGES_SEQUENCES_SELECT_AVATAR_LABEL",
  MESSAGES_SEQUENCES_NO_PROSPECT_BADGE: "MESSAGES_SEQUENCES_NO_PROSPECT_BADGE",
  MESSAGES_SEQUENCES_NO_PROSPECT_TITLE: "MESSAGES_SEQUENCES_NO_PROSPECT_TITLE",
  MESSAGES_SEQUENCES_NO_PROSPECT_DESCRIPTION: "MESSAGES_SEQUENCES_NO_PROSPECT_DESCRIPTION",
  MESSAGES_SEQUENCES_NO_PROSPECT_BUTTON: "MESSAGES_SEQUENCES_NO_PROSPECT_BUTTON",
  MESSAGES_SEQUENCES_CHANNEL_LABEL: "MESSAGES_SEQUENCES_CHANNEL_LABEL",
  MESSAGES_SEQUENCES_CHANNEL_LINKEDIN: "MESSAGES_SEQUENCES_CHANNEL_LINKEDIN",
  MESSAGES_SEQUENCES_CHANNEL_EMAIL: "MESSAGES_SEQUENCES_CHANNEL_EMAIL",
  MESSAGES_SEQUENCES_CHANNEL_WHATSAPP: "MESSAGES_SEQUENCES_CHANNEL_WHATSAPP",
  MESSAGES_SEQUENCES_STEP_OPENING: "MESSAGES_SEQUENCES_STEP_OPENING",
  MESSAGES_SEQUENCES_STEP_FOLLOW_UP_1: "MESSAGES_SEQUENCES_STEP_FOLLOW_UP_1",
  MESSAGES_SEQUENCES_STEP_FOLLOW_UP_2: "MESSAGES_SEQUENCES_STEP_FOLLOW_UP_2",
  MESSAGES_SEQUENCES_STEP_FOLLOW_UP_3: "MESSAGES_SEQUENCES_STEP_FOLLOW_UP_3",
  MESSAGES_SEQUENCES_STEP_BREAK_UP: "MESSAGES_SEQUENCES_STEP_BREAK_UP",
  MESSAGES_SEQUENCES_ADD_STEP: "MESSAGES_SEQUENCES_ADD_STEP",
  MESSAGES_SEQUENCES_ADD_STEP_PLACEHOLDER: "MESSAGES_SEQUENCES_ADD_STEP_PLACEHOLDER",
  MESSAGES_SEQUENCES_DELETE_STEP: "MESSAGES_SEQUENCES_DELETE_STEP",
  MESSAGES_SEQUENCES_EDIT_STEP: "MESSAGES_SEQUENCES_EDIT_STEP",
  MESSAGES_SEQUENCES_STEP_MODAL_ADD_TITLE: "MESSAGES_SEQUENCES_STEP_MODAL_ADD_TITLE",
  MESSAGES_SEQUENCES_STEP_MODAL_EDIT_TITLE: "MESSAGES_SEQUENCES_STEP_MODAL_EDIT_TITLE",
  MESSAGES_SEQUENCES_STEP_ADD_CTA: "MESSAGES_SEQUENCES_STEP_ADD_CTA",
  MESSAGES_SEQUENCES_STEP_ALREADY_USED: "MESSAGES_SEQUENCES_STEP_ALREADY_USED",
  MESSAGES_SEQUENCES_STEP_TYPE_LABEL: "MESSAGES_SEQUENCES_STEP_TYPE_LABEL",
  MESSAGES_SEQUENCES_STEP_DELAY_LABEL: "MESSAGES_SEQUENCES_STEP_DELAY_LABEL",
  MESSAGES_SEQUENCES_STEP_DELAY_PLACEHOLDER: "MESSAGES_SEQUENCES_STEP_DELAY_PLACEHOLDER",
  MESSAGES_SEQUENCES_TEMPLATE_LABEL: "MESSAGES_SEQUENCES_TEMPLATE_LABEL",
  MESSAGES_SEQUENCES_TEMPLATE_PLACEHOLDER: "MESSAGES_SEQUENCES_TEMPLATE_PLACEHOLDER",
  MESSAGES_SEQUENCES_TEMPLATE_HINT: "MESSAGES_SEQUENCES_TEMPLATE_HINT",
  MESSAGES_SEQUENCES_STEP_AI_RULES_LABEL: "MESSAGES_SEQUENCES_STEP_AI_RULES_LABEL",
  MESSAGES_SEQUENCES_STEP_AI_RULES_PLACEHOLDER: "MESSAGES_SEQUENCES_STEP_AI_RULES_PLACEHOLDER",
  MESSAGES_SEQUENCES_REGENERATE_STEP: "MESSAGES_SEQUENCES_REGENERATE_STEP",
  MESSAGES_SEQUENCES_REGENERATE_STEP_MODAL_TITLE: "MESSAGES_SEQUENCES_REGENERATE_STEP_MODAL_TITLE",
  MESSAGES_SEQUENCES_REGENERATE_STEP_DESCRIPTION: "MESSAGES_SEQUENCES_REGENERATE_STEP_DESCRIPTION",
  MESSAGES_SEQUENCES_REGENERATE_STEP_CTA: "MESSAGES_SEQUENCES_REGENERATE_STEP_CTA",
  MESSAGES_SEQUENCES_DELETE_STEP_TITLE: "MESSAGES_SEQUENCES_DELETE_STEP_TITLE",
  MESSAGES_SEQUENCES_DELETE_STEP_TEXT: "MESSAGES_SEQUENCES_DELETE_STEP_TEXT",
  MESSAGES_SEQUENCES_DELETE_STEP_CONFIRM: "MESSAGES_SEQUENCES_DELETE_STEP_CONFIRM",
  MESSAGES_SEQUENCES_DELAY_DAY: "MESSAGES_SEQUENCES_DELAY_DAY",
  MESSAGES_SEQUENCES_DELAY_HOUR: "MESSAGES_SEQUENCES_DELAY_HOUR",
  MESSAGES_SEQUENCES_DELAY_MINUTE: "MESSAGES_SEQUENCES_DELAY_MINUTE",
  MESSAGES_SEQUENCES_DELAY_UNIT_LABEL: "MESSAGES_SEQUENCES_DELAY_UNIT_LABEL",
  MESSAGES_SEQUENCES_DELAY_UNIT_DAY: "MESSAGES_SEQUENCES_DELAY_UNIT_DAY",
  MESSAGES_SEQUENCES_DELAY_UNIT_HOUR: "MESSAGES_SEQUENCES_DELAY_UNIT_HOUR",
  MESSAGES_SEQUENCES_DELAY_UNIT_MINUTE: "MESSAGES_SEQUENCES_DELAY_UNIT_MINUTE",
  MESSAGES_SEQUENCES_GENERATE_MODAL_TITLE: "MESSAGES_SEQUENCES_GENERATE_MODAL_TITLE",
  MESSAGES_SEQUENCES_GENERATE_DESCRIPTION: "MESSAGES_SEQUENCES_GENERATE_DESCRIPTION",
  MESSAGES_SEQUENCES_REGENERATE_MODAL_TITLE: "MESSAGES_SEQUENCES_REGENERATE_MODAL_TITLE",
  MESSAGES_SEQUENCES_VARIANTS_COUNT_LABEL: "MESSAGES_SEQUENCES_VARIANTS_COUNT_LABEL",
  MESSAGES_SEQUENCES_VARIANT_ONE: "MESSAGES_SEQUENCES_VARIANT_ONE",
  MESSAGES_SEQUENCES_VARIANT_MANY: "MESSAGES_SEQUENCES_VARIANT_MANY",
  MESSAGES_SEQUENCES_GENERATE_ERROR: "MESSAGES_SEQUENCES_GENERATE_ERROR",
  MESSAGES_SEQUENCES_REGENERATE_DESCRIPTION: "MESSAGES_SEQUENCES_REGENERATE_DESCRIPTION",
  MESSAGES_SEQUENCES_MENU_VARIANT_SECTION: "MESSAGES_SEQUENCES_MENU_VARIANT_SECTION",
  MESSAGES_SEQUENCES_MENU_STEP_SECTION: "MESSAGES_SEQUENCES_MENU_STEP_SECTION",
  MESSAGES_SEQUENCES_GUIDE_TITLE: "MESSAGES_SEQUENCES_GUIDE_TITLE",
  MESSAGES_SEQUENCES_GUIDE_STEP_1: "MESSAGES_SEQUENCES_GUIDE_STEP_1",
  MESSAGES_SEQUENCES_GUIDE_STEP_2: "MESSAGES_SEQUENCES_GUIDE_STEP_2",
  MESSAGES_SEQUENCES_GUIDE_STEP_3: "MESSAGES_SEQUENCES_GUIDE_STEP_3",
  MESSAGES_SEQUENCES_GUIDE_STEP_4: "MESSAGES_SEQUENCES_GUIDE_STEP_4",
  MESSAGES_SEQUENCES_GUIDE_INSTALL: "MESSAGES_SEQUENCES_GUIDE_INSTALL",
  MESSAGES_SEQUENCES_GUIDE_DESCRIPTION: "MESSAGES_SEQUENCES_GUIDE_DESCRIPTION",
  MESSAGES_SEQUENCES_GUIDE_LEAD: "MESSAGES_SEQUENCES_GUIDE_LEAD",
  MESSAGES_SEQUENCES_GUIDE_SIGNUP: "MESSAGES_SEQUENCES_GUIDE_SIGNUP",
  MESSAGES_SEQUENCES_VARIANT: "MESSAGES_SEQUENCES_VARIANT",
  MESSAGES_SEQUENCES_ADD_VARIANT: "MESSAGES_SEQUENCES_ADD_VARIANT",
  MESSAGES_SEQUENCES_EDIT_VARIANT: "MESSAGES_SEQUENCES_EDIT_VARIANT",
  MESSAGES_SEQUENCES_DELETE_VARIANT: "MESSAGES_SEQUENCES_DELETE_VARIANT",
  MESSAGES_SEQUENCES_VARIANT_MODAL_ADD_TITLE: "MESSAGES_SEQUENCES_VARIANT_MODAL_ADD_TITLE",
  MESSAGES_SEQUENCES_VARIANT_MODAL_EDIT_TITLE: "MESSAGES_SEQUENCES_VARIANT_MODAL_EDIT_TITLE",
  MESSAGES_SEQUENCES_VARIANT_LABEL_LABEL: "MESSAGES_SEQUENCES_VARIANT_LABEL_LABEL",
  MESSAGES_SEQUENCES_VARIANT_LABEL_PLACEHOLDER: "MESSAGES_SEQUENCES_VARIANT_LABEL_PLACEHOLDER",
  MESSAGES_SEQUENCES_DELETE_VARIANT_TITLE: "MESSAGES_SEQUENCES_DELETE_VARIANT_TITLE",
  MESSAGES_SEQUENCES_DELETE_VARIANT_TEXT: "MESSAGES_SEQUENCES_DELETE_VARIANT_TEXT",
  MESSAGES_SEQUENCES_DELETE_VARIANT_CONFIRM: "MESSAGES_SEQUENCES_DELETE_VARIANT_CONFIRM",
  MESSAGES_SEQUENCES_OBJECTIVE_LABEL: "MESSAGES_SEQUENCES_OBJECTIVE_LABEL",
  MESSAGES_SEQUENCES_OBJECTIVE_PLACEHOLDER: "MESSAGES_SEQUENCES_OBJECTIVE_PLACEHOLDER",
  MESSAGES_SEQUENCES_OBJECTIVE_ADD: "MESSAGES_SEQUENCES_OBJECTIVE_ADD",
  MESSAGES_SEQUENCES_OBJECTIVE_EDIT: "MESSAGES_SEQUENCES_OBJECTIVE_EDIT",
  MESSAGES_SEQUENCES_OBJECTIVE_ADD_TITLE: "MESSAGES_SEQUENCES_OBJECTIVE_ADD_TITLE",
  MESSAGES_SEQUENCES_OBJECTIVE_EDIT_TITLE: "MESSAGES_SEQUENCES_OBJECTIVE_EDIT_TITLE",
  MESSAGES_SEQUENCES_OBJECTIVE_DESCRIPTION: "MESSAGES_SEQUENCES_OBJECTIVE_DESCRIPTION",
  MESSAGES_SEQUENCES_OBJECTIVE_NAME_LABEL: "MESSAGES_SEQUENCES_OBJECTIVE_NAME_LABEL",
  MESSAGES_SEQUENCES_OBJECTIVE_DETAIL_LABEL: "MESSAGES_SEQUENCES_OBJECTIVE_DETAIL_LABEL",
  MESSAGES_SEQUENCES_OBJECTIVE_DETAIL_PLACEHOLDER:
    "MESSAGES_SEQUENCES_OBJECTIVE_DETAIL_PLACEHOLDER",
  MESSAGES_SEQUENCES_OBJECTIVE_DELETE_TITLE: "MESSAGES_SEQUENCES_OBJECTIVE_DELETE_TITLE",
  MESSAGES_SEQUENCES_OBJECTIVE_DELETE_TEXT: "MESSAGES_SEQUENCES_OBJECTIVE_DELETE_TEXT",
  MESSAGES_SEQUENCES_OBJECTIVE_DELETE_CONFIRM: "MESSAGES_SEQUENCES_OBJECTIVE_DELETE_CONFIRM",
  MESSAGES_SEQUENCES_OBJECTIVE_LIMIT: "MESSAGES_SEQUENCES_OBJECTIVE_LIMIT",
  MESSAGES_SEQUENCES_OBJECTIVE_EMPTY_TITLE: "MESSAGES_SEQUENCES_OBJECTIVE_EMPTY_TITLE",
  MESSAGES_SEQUENCES_OBJECTIVE_EMPTY_TEXT: "MESSAGES_SEQUENCES_OBJECTIVE_EMPTY_TEXT",
  MESSAGES_SEQUENCES_OBJECTIVE_EMPTY_EXAMPLES: "MESSAGES_SEQUENCES_OBJECTIVE_EMPTY_EXAMPLES",
  MESSAGES_SEQUENCES_OBJECTIVE_EMPTY_READER: "MESSAGES_SEQUENCES_OBJECTIVE_EMPTY_READER",
  MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_1: "MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_1",
  MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_2: "MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_2",
  MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_3: "MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_3",
  MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_4: "MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_4",
  MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_5: "MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_5",
  MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_6: "MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_6",
  MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_7: "MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_7",
  MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_8: "MESSAGES_SEQUENCES_OBJECTIVE_SUGGESTION_8",
  MESSAGES_SEQUENCES_AI_RULES_LABEL: "MESSAGES_SEQUENCES_AI_RULES_LABEL",
  MESSAGES_SEQUENCES_AI_RULES_PLACEHOLDER: "MESSAGES_SEQUENCES_AI_RULES_PLACEHOLDER",
  MESSAGES_SEQUENCES_GENERATING: "MESSAGES_SEQUENCES_GENERATING",
  MESSAGES_SEQUENCES_GENERATE_CTA: "MESSAGES_SEQUENCES_GENERATE_CTA",
  MESSAGES_SEQUENCES_REGENERATE_CTA: "MESSAGES_SEQUENCES_REGENERATE_CTA",
  MESSAGES_SEQUENCES_AVATAR_UPDATED: "MESSAGES_SEQUENCES_AVATAR_UPDATED",
  MESSAGES_SEQUENCES_COLLAPSE: "MESSAGES_SEQUENCES_COLLAPSE",
} as const;
